/**
 * @typedef {object} CodeObject
 * @prop {string} code
 * @prop {string} compra_id
 * @prop {Date} keep_alive
 */

import {
  FIREBASE_CHAVE_SERVER,
  RECAPTCHA_ENTERPRISE_KEY,
  APPCHECK_DEBUG_TOKEN,
} from "@/constants/keys";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import {
  initializeAppCheck,
  ReCaptchaV3Provider,
  getToken,
} from "firebase/app-check";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import etapaCompra from "../constants/etapaCompra";
import router from "../router";
import store from "../store";
firebase.initializeApp(FIREBASE_CHAVE_SERVER);

// App Check — inicializar logo após o initializeApp
if (APPCHECK_DEBUG_TOKEN) {
  // eslint-disable-next-line no-undef
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = APPCHECK_DEBUG_TOKEN;
}
export const appCheck = RECAPTCHA_ENTERPRISE_KEY
  ? initializeAppCheck(firebase.app(), {
      provider: new ReCaptchaV3Provider(RECAPTCHA_ENTERPRISE_KEY),
      isTokenAutoRefreshEnabled: true,
    })
  : null;

export const db = firebase.firestore();
export const auth = firebase.auth();
export const storage = firebase.storage();
export const storageRef = storage.ref();

// Helper para obter o token do App Check
export async function getAppCheckToken() {
  if (!appCheck) return null;
  try {
    const result = await getToken(appCheck);
    return result.token;
  } catch {
    return null;
  }
}

/**
 * Retorna um code
 *
 * @param {string} code
 * @returns {Map<CodeObject>}
 */

/**
 *
 * @param {*} compraId
 * @returns {Promise<Map>}
 */

export async function CarregaDadosDaCompra(compraId) {
  return new Promise((resolve, reject) => {
    if (!compraId) return reject(new Error("Compra ID não fornecido."));
    const docRef = doc(db, "compras", compraId);
    if (!docRef) return reject(new Error("Referência do documento inválida."));
    getDoc(docRef)
      .then((docSnap) => {
        if (docSnap.exists()) {
          resolve(docSnap.data());
        } else {
          reject(new Error("Documento não encontrado"));
        }
      })
      .catch((error) => {
        console.error("Erro ao carregar dados da compra:", error);
        reject(error);
      });
  });
}

export async function AtivaTotemNoModoUpload() {
  return new Promise((resolve, reject) => {
    const compra_id = localStorage.getItem("compra_id");
    if (!compra_id) {
      reject(new Error("Compra ID não encontrado no armazenamento local."));
      return;
    }
    const docRef = doc(db, "compras", `${compra_id}`);
    setDoc(docRef, { etapa: etapaCompra.UPLOAD }, { merge: true })
      .then(() => {
        resolve();
      })
      .catch((error) => {
        console.error("Erro ao atualizar a etapa da compra:", error);
        reject(error);
      });
  });
}

export function loggerError(error, dadosComponent = null) {
  if (process.env.NODE_ENV === "development") {
    console.error("Erro capturado:", error);
    return;
  }

  const docRef = collection(db, "logError");
  const routerActive = router.currentRoute.path;
  const compraStored = store.getters["compra/getCompra"];

  // Serializa o erro antes de enviar ao Firestore
  const errorSerializado =
    error instanceof Error
      ? { mensagem: error.message, stack: error.stack, nome: error.name }
      : { mensagem: String(error) };

  // Sem await intencional — fire and forget, não bloqueia o fluxo
  addDoc(docRef, {
    error: errorSerializado,
    timestamp: serverTimestamp(),
    routerActive: routerActive,
    compra: compraStored,
    dataComponent: dadosComponent,
    categoria: "mobile",
  }).catch((err) => {
    // Falha silenciosa — log só no console para não propagar erro
    console.warn("Falha ao registrar erro no Firestore:", err);
  });
}

export { firebase };
